import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  buildFiveSegmentsTableInfo,
  type FiveSegmentColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { useHighlightCells } from '~/hooks/useHighlightCells'
import { useTamRatio } from '~/hooks/useTamRatio'
import { type RowInfo } from '~/utils'

import {
  dataDisplayTypeAtom,
  fiveSegmentHiddenColumnKeysAtom,
  fiveSegmentSortValueAtom,
  hiddenRowIdsAtom,
} from '../atoms'

import { useFiveSegmentsBrandsData } from './useFiveSegmentsBrandsData'

type FiveSegmentsTableInfoStyles = {
  indicatorPad: string
}

export const useFiveSegmentsTableInfo = (
  styles: FiveSegmentsTableInfoStyles,
): RowInfo<FiveSegmentColumnKey>[] => {
  const { t } = useTranslation()
  const tamRatio = useTamRatio()

  const dataDisplayType = useAtomValue(dataDisplayTypeAtom)
  const sortValue = useAtomValue(fiveSegmentSortValueAtom)
  const hiddenRowIds = useAtomValue(hiddenRowIdsAtom)
  const hiddenColumnKeys = useAtomValue(fiveSegmentHiddenColumnKeysAtom)

  const brandsData = useFiveSegmentsBrandsData()

  const { addHighlightProps } = useHighlightCells('customer-analysis')

  return React.useMemo(
    () =>
      buildFiveSegmentsTableInfo({
        addHighlightProps,
        brandsData,
        dataDisplayType,
        hiddenColumnKeys,
        hiddenRowIds,
        indicatorPadClassName: styles.indicatorPad,
        sortValue,
        t,
        tamRatio,
      }),
    [
      addHighlightProps,
      brandsData,
      dataDisplayType,
      hiddenColumnKeys,
      hiddenRowIds,
      sortValue,
      styles.indicatorPad,
      t,
      tamRatio,
    ],
  )
}
